const SESSION_KEY = 'geo_ip_location';
const TIMEOUT_MS = 5000;

let inflight: Promise<IpLocationData | null> | null = null;

export interface IpLocationData {
    ip: string;
    country_code: string;
}

export async function getIpLocation(): Promise<IpLocationData | null> {
    if (typeof window === 'undefined') return null;

    try {
        const cached = sessionStorage.getItem(SESSION_KEY);
        if (cached) return JSON.parse(cached);
    } catch {
        /* ignore storage errors */
    }

    if (inflight) return inflight;

    // Forms wait on this before rendering, so a hung /api must not block them.
    const controller =
        typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeout = setTimeout(() => controller?.abort(), TIMEOUT_MS);

    inflight = fetch(`${window.location.origin}/api`, {
        signal: controller?.signal,
    })
        .then((res) => {
            if (!res.ok) throw new Error(`/api returned ${res.status}`);
            return res.json();
        })
        .then((data: IpLocationData) => {
            try {
                sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
            } catch {
                /* ignore storage errors */
            }
            return data;
        })
        .catch(() => null)
        .finally(() => {
            clearTimeout(timeout);
            inflight = null;
        });

    return inflight;
}
